export default __webpack_public_path__ + "static/media/classificacao-nivel.aa32df17.png";